import { Component, OnInit } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { QualityGateService } from "../../../../../api/services/quality-gate.service";
import { MessageService } from "primeng/api";
import { QualityGateFilter } from "../../../../../api/models/quality-gate-filter";
import { DuplicateTradingPlanEntry } from "../../../../../api/models/duplicate-trading-plan-entry";
import { ViewDuplicatePlansFilingsComponent } from "../../modals/view-duplicate-plans-filings/view-duplicate-plans-filings.component";

@Component({
  selector: "app-duplicate-plans-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class DuplicatePlansUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  unprocessedDuplicatePlansEntries: DuplicateTradingPlanEntry[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedDuplicatePlans();
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedDuplicatePlans();
  }
  getUnprocessedDuplicatePlans() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "Duplicate_Trading_Plan",
      issuerName: this.issuerName ? this.issuerName : undefined,
      insiderName: this.insiderName ? this.insiderName : undefined,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedDuplicatePlansEntries =
          value.duplicateTradingPlanEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedDuplicatePlansEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  openDuplicatePlansFilingModal(share: any) {
    const selectedData = share;
    this.ref = this.dialogService.open(ViewDuplicatePlansFilingsComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
      header: "View Duplicate Plan Filing",
      data: selectedData,
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getUnprocessedDuplicatePlans();
      }
    });
  }
}
